import React, { Component } from 'react'
import { Field } from 'redux-form/immutable'
import cn from 'classnames'

import Button from 'app/components/ButtonDefault'
import TextArea from 'app/components/TextArea'
import Text from 'app/components/Text'
import { WhiteCard } from 'app/components/WhiteCard'

import './styles.scss'

const bc = 'user-story-form'

class UserStoryForm extends Component {
  state = {
    showUsersTooltip: false,
  }

  render() {
    const {
      t,
      handleSubmit,
      pristine,
      submitting,
      valid,
      className,
      title,
      activityName,
      activityDay,
      question,
      buttonTitle,
      lastStoryProTrack,
      activityDescription,
      renderButtons,
    } = this.props
    return (
      <form onSubmit={handleSubmit}>
        <WhiteCard className={cn(bc, { [className]: !!className }, { [`${bc}__padding`]: lastStoryProTrack })}>
          {!lastStoryProTrack && <Text customTitleClass={`${bc}__title`}>{title || 'Activity Completed'}</Text>}
          <Text htmlTag="h4">{question || `${activityDay}. ${activityName}`}</Text>
          <Text customTitleClass={`${bc}__subtitle`} isSubtitle>
            {activityDescription}
          </Text>

          <Field
            name="story"
            component={TextArea}
            className={`${bc}__input-wrapper`}
            classTextArea={`${bc}__input`}
            classNumberOfLetters={`${bc}__counter`}
            placeholder={t('Please write here')}
            maxCharacters={400}
            availableMentionOptions
          />
          <Text customTitleClass={`${bc}__message`} isSubtitle>
            You can tag someone in the story using “@“ before name
          </Text>
          <Button
            type="submit"
            className={cn(`${bc}__button`, { [`${bc}__button-hide`]: lastStoryProTrack })}
            disabled={pristine || submitting || !valid}
          >
            {buttonTitle || t('ADD STORY')}
          </Button>
        </WhiteCard>
        {lastStoryProTrack && renderButtons && renderButtons()}
      </form>
    )
  }
}

export default UserStoryForm
